import React from "react";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import { Header } from "arv-extends";

import { TOPBAR } from "npmlinks-constants";

const { wrapper, getFinalComponent } = Header.DesktopHeader.DesktopTopBar;
const { StoreLocatorActionButton, LoginActionButton } = Header.ActionButtons;

class HeaderDesktopTopBar extends wrapper {
  render() {
    return (
      <GridContainer className={`nw-topbar ${this.isFixedClassName}`}>
        <GridRow className="nw-topbar-row">
          <GridColumn className="nw-topbar-col nw-topbar-colleft">
            <a
              href={TOPBAR.CIRCLE_PROGRAM_URL}
              className="wc-topbar-links"
              target="_self"
            >
              {TOPBAR.CIRCLE_PROGRAM_TEXT}
            </a>
            <span className="wc-topbar-separator">|</span>
            <a
              href={TOPBAR.CORPORATE_GIFTING_URL}
              className="wc-topbar-links"
              target="_self"
            >
              {TOPBAR.CORPORATE_GIFTING_TEXT}
            </a>
            <span className="wc-topbar-separator">|</span>
            <a
              href={TOPBAR.PRODUCT_VERIFICATION_URL}
              className="wc-topbar-links"
              target="_self"
            >
              {TOPBAR.PRODUCT_VERIFICATION_TEXT}
            </a>
          </GridColumn>
          <GridColumn className="nw-topbar-col nw-topbar-colcenter" />
          <GridColumn className="nw-topbar-col nw-topbar-colright">
            <StoreLocatorActionButton.component
              className="nw-topbar-storelocator"
              text="STORE LOCATOR"
            />
            <LoginActionButton.component text="LOGIN" />
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

Header.DesktopHeader.DesktopTopBar.component = getFinalComponent(
  HeaderDesktopTopBar
);
